(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hand-patch-customizer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function initCustomizer(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    document.body.classList.add('hand-customizer-page');

    var baseImage = root.querySelector('[data-base-image]');
    var zone = root.querySelector('[data-design-zone]');
    var variantButtons = Array.from(root.querySelectorAll('[data-variant-button]'));
    var swatchButtons = Array.from(root.querySelectorAll('[data-swatch-button]'));
    var patchButtons = Array.from(root.querySelectorAll('[data-patch-button]'));
    var patchSearch = root.querySelector('[data-patch-search]');
    var patchGrid = root.querySelector('[data-patch-grid]');
    var patchCategories = root.querySelector('[data-patch-categories]');
    var patchShowMore = root.querySelector('[data-patch-show-more]');
    var patchCarouselNav = root.querySelector('[data-patch-carousel-nav]');
    var patchPrev = root.querySelector('[data-patch-prev]');
    var patchNext = root.querySelector('[data-patch-next]');
    var patchResultCount = root.querySelector('[data-patch-result-count]');
    var patchEmpty = root.querySelector('[data-patch-empty]');
    var selectedPatchTray = root.querySelector('[data-selected-patch-tray]');
    var selectedPatchList = root.querySelector('[data-selected-patch-list]');
    var selectedPatchTotal = root.querySelector('[data-selected-patch-total]');
    var stage = root.querySelector('[data-stage]');
    var zoomContent = root.querySelector('[data-zoom-content]');
    var zoomControls = root.querySelector('[data-zoom-controls]');
    var zoomOutButton = root.querySelector('[data-zoom-out]');
    var zoomResetButton = root.querySelector('[data-zoom-reset]');
    var zoomInButton = root.querySelector('[data-zoom-in]');
    var editPanel = root.querySelector('[data-edit-panel]');
    var selectedName = root.querySelector('[data-selected-name]');
    var selectedSize = root.querySelector('[data-selected-size]');
    var patchCount = root.querySelector('[data-patch-count]');
    var totalPrice = root.querySelector('[data-total-price]');
    var addButton = root.querySelector('[data-add-customized]');
    var status = root.querySelector('[data-status]');
    var editBanner = root.querySelector('[data-hand-edit-banner]');
    var cancelEditButton = root.querySelector('[data-hand-cancel-edit]');
    var editDraft = null;
    var currency = root.dataset.currency || 'MYR';
    var bagWidthCm = Number(root.dataset.bagWidthCm || 21);
    var bagHeightCm = Number(root.dataset.bagHeightCm || 22.5);
    var placementMarginCm = Number(root.dataset.placementMarginCm || 0);
    var doubleSided = root.dataset.doubleSided === 'true';
    var productBackImage = root.dataset.backImage || '';
    var surfaceButtons = Array.from(root.querySelectorAll('[data-surface-button]'));
    var surfaceCountNodes = Array.from(root.querySelectorAll('[data-surface-count]'));

    var state = {
      variantId: '',
      variantTitle: '',
      basePrice: 0,
      placements: [],
      selectedUid: null,
      counter: 0,
      patchQuery: '',
      patchCategory: 'All',
      patchVisibleLimit: 12,
      surface: 'front',
      frontImage: baseImage ? baseImage.src : '',
      currentBackImage: ''
    };

    // Zoom affects only the on-screen preview. Patch sizes and saved placement coordinates stay unchanged.
    var zoomLevels = [1, 1.5, 2, 2.5, 3];
    var zoomLevelIndex = 0;
    var previewPanX = 0;
    var previewPanY = 0;
    var suppressPanClick = false;

    function applyPreviewZoom() {
      if (!stage || !zoomContent) return;
      var zoom = zoomLevels[zoomLevelIndex];
      var maxPanX = Math.max(0, (zoom - 1) * stage.clientWidth / 2);
      var maxPanY = Math.max(0, (zoom - 1) * stage.clientHeight / 2);
      previewPanX = clamp(previewPanX, -maxPanX, maxPanX);
      previewPanY = clamp(previewPanY, -maxPanY, maxPanY);

      // Zoom the entire preview together, so the bag and patches keep the
      // same physical proportions at 100%, 150%, 200%, 250% and 300%.
      zoomContent.style.setProperty('--hand-preview-zoom', zoom);
      zoomContent.style.setProperty('--hand-pan-x', previewPanX + 'px');
      zoomContent.style.setProperty('--hand-pan-y', previewPanY + 'px');
      stage.classList.toggle('is-zoomed', zoom > 1);

      if (zoomResetButton) zoomResetButton.textContent = Math.round(zoom * 100) + '%';
      if (zoomOutButton) zoomOutButton.disabled = zoomLevelIndex === 0;
      if (zoomInButton) zoomInButton.disabled = zoomLevelIndex === zoomLevels.length - 1;
    }

    function changePreviewZoom(step) {
      zoomLevelIndex = clamp(zoomLevelIndex + step, 0, zoomLevels.length - 1);
      if (zoomLevelIndex === 0) {
        previewPanX = 0;
        previewPanY = 0;
      }
      applyPreviewZoom();
    }

    if (zoomControls) {
      zoomControls.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
      });
      zoomControls.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
    if (zoomOutButton) zoomOutButton.addEventListener('click', function () {
      changePreviewZoom(-1);
    });
    if (zoomInButton) zoomInButton.addEventListener('click', function () {
      changePreviewZoom(1);
    });
    if (zoomResetButton) zoomResetButton.addEventListener('click', function () {
      zoomLevelIndex = 0;
      previewPanX = 0;
      previewPanY = 0;
      applyPreviewZoom();
    });

    if (stage) {
      // At >100%, drag empty image space to pan. Existing patch drag/rotate remains untouched.
      stage.addEventListener('pointerdown', function (event) {
        if (zoomLevelIndex === 0 || (event.button !== undefined && event.button !== 0)) return;
        if (event.pointerType === 'touch' && !event.isPrimary) return;
        if (event.target.closest('[data-zoom-controls], .hand-patch-customizer__placed-patch')) return;

        var pointerId = event.pointerId;
        var startX = event.clientX;
        var startY = event.clientY;
        var startPanX = previewPanX;
        var startPanY = previewPanY;
        var moved = false;
        stage.classList.add('is-panning');
        stage.setPointerCapture(pointerId);

        function movePan(moveEvent) {
          if (moveEvent.pointerId !== pointerId) return;
          var dx = moveEvent.clientX - startX;
          var dy = moveEvent.clientY - startY;
          if (Math.abs(dx) > 5 || Math.abs(dy) > 5) moved = true;
          previewPanX = startPanX + dx;
          previewPanY = startPanY + dy;
          applyPreviewZoom();
        }

        function stopPan(endEvent) {
          if (endEvent.pointerId !== pointerId) return;
          if (moved) suppressPanClick = true;
          stage.classList.remove('is-panning');
          if (stage.hasPointerCapture(pointerId)) stage.releasePointerCapture(pointerId);
          stage.removeEventListener('pointermove', movePan);
          stage.removeEventListener('pointerup', stopPan);
          stage.removeEventListener('pointercancel', stopPan);
        }

        stage.addEventListener('pointermove', movePan);
        stage.addEventListener('pointerup', stopPan);
        stage.addEventListener('pointercancel', stopPan);
      });

      stage.addEventListener('click', function (event) {
        if (!suppressPanClick) return;
        suppressPanClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }

    window.addEventListener('resize', applyPreviewZoom);
    applyPreviewZoom();

    var money = new Intl.NumberFormat('en-MY', {
      style: 'currency',
      currency: currency
    });

    function activeBackImage() {
      if (state.currentBackImage) return state.currentBackImage;
      if (variantButtons.length <= 1 && productBackImage) return productBackImage;
      return state.frontImage;
    }

        function surfaceZoneValue(surface, key) {
      var prefix = surface === 'back' ? 'back' : 'front';
      var datasetKey = prefix + 'Zone' + key.charAt(0).toUpperCase() + key.slice(1);
      return root.dataset[datasetKey] || '';
    }

    function renderSurface(surface) {
      state.surface = surface === 'back' && doubleSided ? 'back' : 'front';

      var left = surfaceZoneValue(state.surface, 'left');
      var top = surfaceZoneValue(state.surface, 'top');
      var width = surfaceZoneValue(state.surface, 'width');
      var height = surfaceZoneValue(state.surface, 'height');

      if (left) zone.style.left = left + '%';
      if (top) zone.style.top = top + '%';
      if (width) zone.style.width = width + '%';

      if (height) {
        zone.classList.add('has-photo-height');
        zone.style.height = height + '%';
        zone.style.aspectRatio = 'auto';
      } else {
        zone.classList.remove('has-photo-height');
        zone.style.removeProperty('height');
        zone.style.removeProperty('aspect-ratio');
      }

      if (baseImage) {
        baseImage.src = state.surface === 'back' ? activeBackImage() : state.frontImage;
      }

      state.placements.forEach(function (item) {
        item.el.hidden = item.surface !== state.surface;
      });

      surfaceButtons.forEach(function (button) {
        var active = button.dataset.surfaceButton === state.surface;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      state.selectedUid = null;
      updateSelectionUI();
    }

        function selectedPlacement() {
      return state.placements.find(function (item) {
        return item.uid === state.selectedUid;
      }) || null;
    }

    function normalizePatchText(value) {
      return String(value || '').toLowerCase().trim();
    }

    function patchMatches(button) {
      var query = normalizePatchText(state.patchQuery);
      var category = button.dataset.patchCategory || 'Other';
      var searchText = normalizePatchText(
        (button.dataset.patchName || '') + ' ' +
        (button.dataset.patchProductTitle || '') + ' ' +
        category
      );

      var matchesQuery = !query || searchText.indexOf(query) !== -1;
      var matchesCategory = state.patchCategory === 'All' || category === state.patchCategory;
      return matchesQuery && matchesCategory;
    }

    function patchPageSize() {
      if (window.matchMedia('(max-width: 900px)').matches) return 9;
      return 12;
    }

    function renderPatchLibrary(resetLimit) {
      var matches = patchButtons.filter(patchMatches);

      if (!patchGrid) return;

      // Every category uses the same swipeable, paged carousel as All.
      patchGrid.classList.add('is-horizontal');
      patchGrid.innerHTML = '';

      patchButtons.forEach(function (button) {
        button.hidden = true;
      });

      var pageSize = patchPageSize();
      for (var start = 0; start < matches.length; start += pageSize) {
        var page = document.createElement('div');
        page.className = 'hand-patch-customizer__patch-page';

        matches.slice(start, start + pageSize).forEach(function (button) {
          button.hidden = false;
          page.appendChild(button);
        });

        patchGrid.appendChild(page);
      }

      if (patchResultCount) {
        var pageCount = matches.length ? Math.ceil(matches.length / pageSize) : 0;
        patchResultCount.textContent = matches.length
          ? matches.length + ' patches' + (pageCount > 1 ? ' · ' + pageCount + ' pages' : '')
          : '';
      }

      if (patchCarouselNav) {
        patchCarouselNav.hidden = matches.length <= pageSize;
      }
      if (patchShowMore) patchShowMore.hidden = true;

      if (resetLimit) {
        patchGrid.style.scrollBehavior = 'auto';
        patchGrid.scrollLeft = 0;
        patchGrid.style.removeProperty('scroll-behavior');
      }

      if (patchEmpty) patchEmpty.hidden = matches.length !== 0;
    }

        function renderPatchCategories() {
      if (!patchCategories) return;

      var priority = ['Malaysia', 'Food', 'Slang', 'Flowers', 'Alphabet', 'Other'];
      var seen = {};
      patchButtons.forEach(function (button) {
        var category = button.dataset.patchCategory || 'Other';
        seen[category] = true;
      });

      var categories = Object.keys(seen).sort(function (a, b) {
        var ai = priority.indexOf(a);
        var bi = priority.indexOf(b);
        if (ai === -1 && bi === -1) return a.localeCompare(b);
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });

      patchCategories.innerHTML = '';
      ['All'].concat(categories).forEach(function (category) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'hand-patch-customizer__category-button';
        button.textContent = category;
        button.classList.toggle('is-active', category === state.patchCategory);
        button.setAttribute('aria-pressed', category === state.patchCategory ? 'true' : 'false');
        button.addEventListener('click', function () {
          state.patchCategory = category;
          Array.from(patchCategories.querySelectorAll('button')).forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          renderPatchLibrary(true);
        });
        patchCategories.appendChild(button);
      });
    }

    function renderSelectedPatchTray() {
      if (!selectedPatchTray || !selectedPatchList || !selectedPatchTotal) return;

      selectedPatchTray.hidden = state.placements.length === 0;
      selectedPatchTotal.textContent = state.placements.length;
      selectedPatchList.innerHTML = '';

      state.placements.forEach(function (item) {
        var chip = document.createElement('div');
        chip.className = 'hand-patch-customizer__selected-chip';

        var selectButton = document.createElement('button');
        selectButton.type = 'button';
        selectButton.className = 'hand-patch-customizer__selected-chip-select';
        selectButton.setAttribute('aria-label', 'Select ' + item.name + ' on the preview');

        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';

        var label = document.createElement('span');
        label.textContent = item.name + (doubleSided ? ' · ' + (item.surface === 'back' ? 'Back' : 'Front') : '');

        selectButton.appendChild(img);
        selectButton.appendChild(label);
        selectButton.addEventListener('click', function () {
          if (item.surface !== state.surface) {
            renderSurface(item.surface);
          }
          selectPlacement(item);
          if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        var removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'hand-patch-customizer__selected-chip-remove';
        removeButton.textContent = '×';
        removeButton.setAttribute('aria-label', 'Remove ' + item.name);
        removeButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          removePlacement(item);
        });

        chip.appendChild(selectButton);
        chip.appendChild(removeButton);
        selectedPatchList.appendChild(chip);
      });
    }

        function updateSummary() {
      var patchesTotal = state.placements.reduce(function (sum, item) {
        return sum + item.price;
      }, 0);
      totalPrice.textContent = money.format((state.basePrice + patchesTotal) / 100);
      patchCount.textContent = state.placements.length + ' selected';

      var frontCount = state.placements.filter(function (item) { return item.surface === 'front'; }).length;
      var backCount = state.placements.filter(function (item) { return item.surface === 'back'; }).length;
      surfaceCountNodes.forEach(function (node) {
        node.textContent = node.dataset.surfaceCount === 'back' ? backCount : frontCount;
      });

      renderSelectedPatchTray();
    }

    function updateSelectionUI() {
      var selected = selectedPlacement();
      state.placements.forEach(function (item) {
        item.el.classList.toggle('is-selected', selected && item.uid === selected.uid);
        item.el.setAttribute('aria-pressed', selected && item.uid === selected.uid ? 'true' : 'false');
      });
      if (selected) {
        editPanel.hidden = false;
        selectedName.textContent = selected.name;
        selectedSize.textContent = 'Actual size: ' + selected.widthCm + ' × ' + selected.heightCm + ' cm';
      } else {
        editPanel.hidden = true;
        selectedName.textContent = '';
        selectedSize.textContent = '';
      }
    }

    function applyPlacement(item) {
      item.widthPct = (item.widthCm / bagWidthCm) * 100;
      item.heightPct = (item.heightCm / bagHeightCm) * 100;
      var halfW = item.widthPct / 2;
      var halfH = item.heightPct / 2;
      var marginXPct = (placementMarginCm / bagWidthCm) * 100;
      var marginYPct = (placementMarginCm / bagHeightCm) * 100;
      var minX = halfW - marginXPct;
      var maxX = 100 - halfW + marginXPct;
      var minY = halfH - marginYPct;
      var maxY = 100 - halfH + marginYPct;

      if (minX > maxX) {
        item.x = 50;
      } else {
        item.x = clamp(item.x, minX, maxX);
      }

      if (minY > maxY) {
        item.y = 50;
      } else {
        item.y = clamp(item.y, minY, maxY);
      }
      item.el.style.left = item.x + '%';
      item.el.style.top = item.y + '%';
      item.el.style.width = item.widthPct + '%';
      item.el.style.height = item.heightPct + '%';
      item.el.style.transform = 'translate(-50%, -50%) rotate(' + item.rotation + 'deg)';
    }

    function selectPlacement(item) {
      state.selectedUid = item ? item.uid : null;
      updateSelectionUI();
    }

    function removePlacement(item) {
      if (!item) return;

      if (item.el) item.el.remove();
      state.placements = state.placements.filter(function (placement) {
        return placement.uid !== item.uid;
      });

      if (state.selectedUid === item.uid) {
        state.selectedUid = null;
      }

      updateSelectionUI();
      updateSummary();
    }

    function bringPlacementToFront(item) {
      if (!item) return;

      state.placements = state.placements.filter(function (placement) {
        return placement.uid !== item.uid;
      });
      state.placements.push(item);

      if (item.el && item.el.parentNode === zone) {
        zone.appendChild(item.el);
      }

      selectPlacement(item);
    }

    function addPatch(button) {
      var widthCm = Number(button.dataset.patchWidthCm || 4);
      var heightCm = Number(button.dataset.patchHeightCm || 4);
      var uid = 'patch-' + (++state.counter);
      var surfacePlacementCount = state.placements.filter(function (placement) {
        return placement.surface === state.surface;
      }).length;
      var item = {
        uid: uid,
        variantId: button.dataset.patchVariantId,
        name: button.dataset.patchName,
        price: Number(button.dataset.patchPrice || 0),
        image: button.dataset.patchImage,
        widthCm: widthCm,
        heightCm: heightCm,
        widthPct: 0,
        heightPct: 0,
        surface: state.surface,
        x: clamp(48 + (surfacePlacementCount % 4) * 4, 20, 80),
        y: clamp(48 + (surfacePlacementCount % 3) * 4, 20, 80),
        rotation: 0,
        el: null
      };

      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'hand-patch-customizer__placed-patch';
      el.setAttribute('aria-label', 'Placed patch: ' + item.name);
      el.setAttribute('aria-pressed', 'false');

      var img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      el.appendChild(img);

      var rotateHandle = document.createElement('span');
      rotateHandle.className = 'hand-patch-customizer__rotate-handle';
      rotateHandle.dataset.rotateHandle = '';
      rotateHandle.textContent = '↻';
      rotateHandle.setAttribute('aria-hidden', 'true');
      rotateHandle.setAttribute('title', 'Rotate patch');
      el.appendChild(rotateHandle);

      var bringFrontHandle = document.createElement('span');
      bringFrontHandle.className = 'hand-patch-customizer__bring-front-handle';
      bringFrontHandle.dataset.bringFrontHandle = '';
      bringFrontHandle.textContent = '↑';
      bringFrontHandle.setAttribute('aria-hidden', 'true');
      bringFrontHandle.setAttribute('title', 'Bring patch to front');
      el.appendChild(bringFrontHandle);

      item.el = el;
      zone.appendChild(el);
      state.placements.push(item);
      applyPlacement(item);
      selectPlacement(item);
      updateSummary();

      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-rotate-handle], [data-bring-front-handle]')) return;
        selectPlacement(item);
      });

      rotateHandle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (rotateHandle.dataset.dragged === 'true') {
          rotateHandle.dataset.dragged = 'false';
          return;
        }

        item.rotation = Math.round((item.rotation + 15) * 10) / 10;
        applyPlacement(item);
      });

      bringFrontHandle.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectPlacement(item);
      });

      bringFrontHandle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        bringPlacementToFront(item);
      });

      rotateHandle.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) return;

        event.preventDefault();
        event.stopPropagation();
        selectPlacement(item);
        rotateHandle.dataset.dragged = 'false';

        var rect = el.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var startAngle = Math.atan2(event.clientY - centerY, event.clientX - centerX);
        var startRotation = item.rotation || 0;

        rotateHandle.setPointerCapture(event.pointerId);

        function rotate(moveEvent) {
          var currentAngle = Math.atan2(moveEvent.clientY - centerY, moveEvent.clientX - centerX);
          var delta = (currentAngle - startAngle) * 180 / Math.PI;

          if (Math.abs(delta) > 2) {
            rotateHandle.dataset.dragged = 'true';
          }

          item.rotation = Math.round((startRotation + delta) * 10) / 10;
          applyPlacement(item);
        }

        function stopRotate(endEvent) {
          if (rotateHandle.hasPointerCapture(endEvent.pointerId)) {
            rotateHandle.releasePointerCapture(endEvent.pointerId);
          }
          rotateHandle.removeEventListener('pointermove', rotate);
          rotateHandle.removeEventListener('pointerup', stopRotate);
          rotateHandle.removeEventListener('pointercancel', stopRotate);
        }

        rotateHandle.addEventListener('pointermove', rotate);
        rotateHandle.addEventListener('pointerup', stopRotate);
        rotateHandle.addEventListener('pointercancel', stopRotate);
      });

      el.addEventListener('pointerdown', function (event) {
        if (event.target.closest('[data-rotate-handle], [data-bring-front-handle]')) return;
        if (event.button !== undefined && event.button !== 0) return;
        selectPlacement(item);
        el.setPointerCapture(event.pointerId);

        function move(moveEvent) {
          var rect = zone.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          item.x = ((moveEvent.clientX - rect.left) / rect.width) * 100;
          item.y = ((moveEvent.clientY - rect.top) / rect.height) * 100;
          applyPlacement(item);
        }

        function end(endEvent) {
          if (el.hasPointerCapture(endEvent.pointerId)) {
            el.releasePointerCapture(endEvent.pointerId);
          }
          el.removeEventListener('pointermove', move);
          el.removeEventListener('pointerup', end);
          el.removeEventListener('pointercancel', end);
        }

        el.addEventListener('pointermove', move);
        el.addEventListener('pointerup', end);
        el.addEventListener('pointercancel', end);
      });
    }

    function getVariantOptions(button) {
      return [
        button ? (button.dataset.option1 || '') : '',
        button ? (button.dataset.option2 || '') : '',
        button ? (button.dataset.option3 || '') : ''
      ];
    }

    function syncSwatches(button) {
      if (!swatchButtons.length || !button) return;

      var selectedOptions = getVariantOptions(button);

      swatchButtons.forEach(function (swatch) {
        var index = Number(swatch.dataset.optionIndex || 1) - 1;
        var active = swatch.dataset.swatchValue === selectedOptions[index];
        swatch.classList.toggle('is-active', active);
        swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      selectedOptions.forEach(function (value, index) {
        var label = root.querySelector('[data-swatch-label-index="' + (index + 1) + '"]');
        if (label && value) label.textContent = value;
      });
    }

    function chooseVariant(button) {
      if (!button) return;

      state.variantId = button.dataset.variantId;
      state.variantTitle = button.dataset.variantTitle;
      state.basePrice = Number(button.dataset.variantPrice || 0);

      if (button.dataset.variantImage) {
        state.frontImage = button.dataset.variantImage;
      }
      state.currentBackImage = button.dataset.variantBackImage || '';
      baseImage.src = state.surface === 'back' ? activeBackImage() : state.frontImage;

      variantButtons.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      syncSwatches(button);
      updateSummary();
    }

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        chooseVariant(button);
      });
    });

    swatchButtons.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var current = variantButtons.find(function (button) {
          return button.dataset.variantId === state.variantId;
        }) || variantButtons[0];

        if (!current) return;

        var selectedOptions = getVariantOptions(current);
        var changedIndex = Number(swatch.dataset.optionIndex || 1) - 1;
        selectedOptions[changedIndex] = swatch.dataset.swatchValue;

        var match = variantButtons.find(function (button) {
          var options = getVariantOptions(button);
          return (
            options[0] === selectedOptions[0] &&
            options[1] === selectedOptions[1] &&
            options[2] === selectedOptions[2]
          );
        });

        if (!match) {
          match = variantButtons.find(function (button) {
            return getVariantOptions(button)[changedIndex] === swatch.dataset.swatchValue;
          });
        }

        if (match) chooseVariant(match);
      });
    });

    patchButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        addPatch(button);
      });
    });

    if (patchSearch) {
      patchSearch.addEventListener('input', function () {
        state.patchQuery = patchSearch.value || '';
        renderPatchLibrary(true);
      });
    }

    if (patchShowMore) {
      patchShowMore.addEventListener('click', function () {
        state.patchVisibleLimit += 12;
        renderPatchLibrary(false);
      });
    }

    function scrollPatchCarousel(direction) {
      if (!patchGrid) return;
      var amount = Math.max(280, patchGrid.clientWidth);
      patchGrid.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }

    if (patchPrev) {
      patchPrev.addEventListener('click', function () {
        scrollPatchCarousel(-1);
      });
    }

    if (patchNext) {
      patchNext.addEventListener('click', function () {
        scrollPatchCarousel(1);
      });
    }

    if (patchGrid) {
      patchGrid.addEventListener('wheel', function (event) {
        if (!patchGrid.classList.contains('is-horizontal')) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        event.preventDefault();
        patchGrid.scrollLeft += event.deltaY;
      }, { passive: false });
    }

    renderPatchCategories();
    renderPatchLibrary(true);

    var patchResizeTimer = null;
    window.addEventListener('resize', function () {
      if (state.patchCategory !== 'All') return;
      window.clearTimeout(patchResizeTimer);
      patchResizeTimer = window.setTimeout(function () {
        renderPatchLibrary(true);
      }, 150);
    });

    surfaceButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        renderSurface(button.dataset.surfaceButton);
      });
    });

    root.querySelectorAll('[data-edit-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = selectedPlacement();
        if (!item) return;
        var action = button.dataset.editAction;

        if (action === 'left') item.x -= 3;
        if (action === 'right') item.x += 3;
        if (action === 'up') item.y -= 3;
        if (action === 'down') item.y += 3;
        if (action === 'rotate-left') item.rotation -= 15;
        if (action === 'rotate-right') item.rotation += 15;

        if (action === 'delete') {
          removePlacement(item);
          return;
        }

        applyPlacement(item);
      });
    });

    zone.addEventListener('click', function (event) {
      if (event.target === zone) selectPlacement(null);
    });

    if (stage) {
      stage.addEventListener('click', function (event) {
        if (event.target.closest('.hand-patch-customizer__placed-patch')) return;
        selectPlacement(null);
      });
    }

    function loadImageForCanvas(src) {
      return new Promise(function (resolve, reject) {
        if (!src) {
          reject(new Error('Missing preview image.'));
          return;
        }

        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = function () { reject(new Error('Could not load an image for the DIY preview.')); };
        img.src = src;
      });
    }

    function drawImageCover(ctx, img, x, y, width, height) {
      var imageRatio = img.naturalWidth / img.naturalHeight;
      var boxRatio = width / height;
      var sx = 0;
      var sy = 0;
      var sw = img.naturalWidth;
      var sh = img.naturalHeight;

      if (imageRatio > boxRatio) {
        sw = img.naturalHeight * boxRatio;
        sx = (img.naturalWidth - sw) / 2;
      } else if (imageRatio < boxRatio) {
        sh = img.naturalWidth / boxRatio;
        sy = (img.naturalHeight - sh) / 2;
      }

      ctx.drawImage(img, sx, sy, sw, sh, x, y, width, height);
    }

    function zoneRectForSurface(surface, stageWidth, stageHeight) {
      var leftPct = Number(surfaceZoneValue(surface, 'left') || 0);
      var topPct = Number(surfaceZoneValue(surface, 'top') || 0);
      var widthPct = Number(surfaceZoneValue(surface, 'width') || 100);
      var heightRaw = surfaceZoneValue(surface, 'height');
      var zoneWidth = stageWidth * (widthPct / 100);
      var zoneHeight;

      if (heightRaw !== '') {
        zoneHeight = stageHeight * (Number(heightRaw) / 100);
      } else {
        zoneHeight = zoneWidth * (bagHeightCm / bagWidthCm);
      }

      return {
        x: stageWidth * (leftPct / 100),
        y: stageHeight * (topPct / 100),
        width: zoneWidth,
        height: zoneHeight
      };
    }

    function highResShopifyImageUrl(src) {
      return String(src || '').replace(/([?&])width=1200(?=&|$)/, '$1width=2400');
    }

    async function renderSurfaceToCanvas(surface) {
      var stageWidth = 1600;
      var stageHeight = 2400;
      var canvas = document.createElement('canvas');
      canvas.width = stageWidth;
      canvas.height = stageHeight;
      var ctx = canvas.getContext('2d');

      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, stageWidth, stageHeight);

      var imageSrc = surface === 'back' ? activeBackImage() : state.frontImage;
      var base = await loadImageForCanvas(highResShopifyImageUrl(imageSrc));
      drawImageCover(ctx, base, 0, 0, stageWidth, stageHeight);

      var rect = zoneRectForSurface(surface, stageWidth, stageHeight);
      var placements = state.placements.filter(function (item) {
        return item.surface === surface;
      });

      for (var index = 0; index < placements.length; index += 1) {
        var item = placements[index];
        var patch = await loadImageForCanvas(item.image);
        var patchWidth = rect.width * ((item.widthCm / bagWidthCm));
        var patchHeight = rect.height * ((item.heightCm / bagHeightCm));
        var centerX = rect.x + rect.width * (item.x / 100);
        var centerY = rect.y + rect.height * (item.y / 100);

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate((item.rotation || 0) * Math.PI / 180);
        ctx.drawImage(
          patch,
          -patchWidth / 2,
          -patchHeight / 2,
          patchWidth,
          patchHeight
        );
        ctx.restore();
      }

      return canvas;
    }

    function canvasToBlob(canvas, type, quality) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Could not generate the DIY preview image.'));
          }
        }, type || 'image/jpeg', quality || 0.92);
      });
    }

    async function buildDiyPreviewFile(customizerId) {
      var surfaces = doubleSided ? ['front', 'back'] : ['front'];
      var rendered = [];

      for (var s = 0; s < surfaces.length; s += 1) {
        rendered.push(await renderSurfaceToCanvas(surfaces[s]));
      }

      var stageWidth = 1600;
      var stageHeight = 2400;
      var labelHeight = 144;
      var footerHeight = 116;
      var gap = 56;
      var outerPad = 56;
      var output = document.createElement('canvas');

      output.width =
        outerPad * 2 +
        rendered.length * stageWidth +
        Math.max(0, rendered.length - 1) * gap;
      output.height = outerPad * 2 + labelHeight + stageHeight + footerHeight;

      var ctx = output.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, output.width, output.height);

      ctx.fillStyle = '#111111';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '600 56px Arial, sans-serif';

      rendered.forEach(function (surfaceCanvas, index) {
        var x = outerPad + index * (stageWidth + gap);
        var label = surfaces[index] === 'back' ? 'BACK' : 'FRONT';
        ctx.fillText(label, x + stageWidth / 2, outerPad + labelHeight / 2);
        ctx.drawImage(surfaceCanvas, x, outerPad + labelHeight, stageWidth, stageHeight);
      });

      ctx.font = '40px Arial, sans-serif';
      ctx.fillStyle = '#555555';
      ctx.fillText(
        'HAND Customizer ID: ' + customizerId,
        output.width / 2,
        outerPad + labelHeight + stageHeight + footerHeight / 2
      );

      var blob = await canvasToBlob(output, 'image/jpeg', 0.95);
      return new File(
        [blob],
        'HAND-DIY-' + customizerId + '.jpg',
        { type: 'image/jpeg' }
      );
    }


    // A second, tightly framed image makes small patch placements legible to fulfilment staff.
    // Draw patches again from their original images, rather than enlarging the rasterised full preview.
    async function renderPatchDetailCanvas(surface) {
      var placements = state.placements.filter(function (item) { return item.surface === surface; });
      if (!placements.length) return null;

      var stageWidth = 1600;
      var stageHeight = 2400;
      var rect = zoneRectForSurface(surface, stageWidth, stageHeight);
      var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

      placements.forEach(function (item) {
        var width = rect.width * (item.widthCm / bagWidthCm);
        var height = rect.height * (item.heightCm / bagHeightCm);
        var radians = (item.rotation || 0) * Math.PI / 180;
        var halfW = (Math.abs(Math.cos(radians)) * width + Math.abs(Math.sin(radians)) * height) / 2;
        var halfH = (Math.abs(Math.sin(radians)) * width + Math.abs(Math.cos(radians)) * height) / 2;
        var centerX = rect.x + rect.width * (item.x / 100);
        var centerY = rect.y + rect.height * (item.y / 100);
        minX = Math.min(minX, centerX - halfW);
        maxX = Math.max(maxX, centerX + halfW);
        minY = Math.min(minY, centerY - halfH);
        maxY = Math.max(maxY, centerY + halfH);
      });

      var spanX = maxX - minX;
      var spanY = maxY - minY;
      var pad = Math.max(90, Math.min(260, Math.max(spanX, spanY) * 0.32));
      var cropWidth = Math.min(stageWidth, Math.max(320, spanX + 2 * pad, (spanY + 2 * pad) * 4 / 3));
      var cropHeight = Math.min(stageHeight, Math.max(cropWidth * 3 / 4, spanY + 2 * pad));
      var cropX = Math.max(0, Math.min(stageWidth - cropWidth, (minX + maxX - cropWidth) / 2));
      var cropY = Math.max(0, Math.min(stageHeight - cropHeight, (minY + maxY - cropHeight) / 2));
      var detailWidth = 1400;
      var scale = detailWidth / cropWidth;
      var canvas = document.createElement('canvas');
      canvas.width = detailWidth;
      canvas.height = Math.round(cropHeight * scale);
      var ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      ctx.scale(scale, scale);
      ctx.translate(-cropX, -cropY);

      var imageSrc = surface === 'back' ? activeBackImage() : state.frontImage;
      var base = await loadImageForCanvas(highResShopifyImageUrl(imageSrc));
      drawImageCover(ctx, base, 0, 0, stageWidth, stageHeight);

      for (var index = 0; index < placements.length; index += 1) {
        var item = placements[index];
        var patch = await loadImageForCanvas(item.image);
        var patchWidth = rect.width * (item.widthCm / bagWidthCm);
        var patchHeight = rect.height * (item.heightCm / bagHeightCm);
        var centerX = rect.x + rect.width * (item.x / 100);
        var centerY = rect.y + rect.height * (item.y / 100);
        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate((item.rotation || 0) * Math.PI / 180);
        ctx.drawImage(patch, -patchWidth / 2, -patchHeight / 2, patchWidth, patchHeight);
        ctx.restore();
      }
      ctx.restore();
      return canvas;
    }

    async function buildDiyDetailFile(customizerId) {
      var surfaces = doubleSided ? ['front', 'back'] : ['front'];
      var details = [];
      for (var index = 0; index < surfaces.length; index += 1) {
        var detail = await renderPatchDetailCanvas(surfaces[index]);
        if (detail) details.push({ surface: surfaces[index], canvas: detail });
      }
      if (!details.length) return null;

      var outerPad = 40;
      var labelHeight = 96;
      var footerHeight = 80;
      var gap = 28;
      var output = document.createElement('canvas');
      output.width = 1400 + outerPad * 2;
      output.height = outerPad * 2 + footerHeight +
        details.reduce(function (sum, item) { return sum + labelHeight + item.canvas.height; }, 0) +
        Math.max(0, details.length - 1) * gap;
      var ctx = output.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, output.width, output.height);
      ctx.fillStyle = '#111111';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '600 38px Arial, sans-serif';
      var cursorY = outerPad;
      details.forEach(function (detail) {
        ctx.fillText(
          (detail.surface === 'back' ? 'BACK' : 'FRONT') + ' — PATCH PLACEMENT DETAIL',
          output.width / 2,
          cursorY + labelHeight / 2
        );
        ctx.drawImage(detail.canvas, outerPad, cursorY + labelHeight);
        cursorY += labelHeight + detail.canvas.height + gap;
      });
      ctx.font = '28px Arial, sans-serif';
      ctx.fillStyle = '#555555';
      ctx.fillText('HAND Customizer ID: ' + customizerId, output.width / 2, output.height - outerPad - footerHeight / 2);
      var blob = await canvasToBlob(output, 'image/jpeg', 0.95);
      return new File([blob], 'HAND-DIY-DETAIL-' + customizerId + '.jpg', { type: 'image/jpeg' });
    }

    async function removeHandCartGroup(groupId) {
      if (!groupId) return;
      var cartUrl = root.dataset.cartUrl.replace(/\/$/, '');
      var cartResponse = await fetch(cartUrl + '.js', {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!cartResponse.ok) throw new Error('Could not verify your cart.');
      var cartData = await cartResponse.json();
      var updates = {};
      (cartData.items || []).forEach(function (line) {
        if (line.properties && line.properties['_HAND Customizer ID'] === groupId) {
          updates[line.key] = 0;
        }
      });
      if (!Object.keys(updates).length) return;
      var updateResponse = await fetch(cartUrl + '/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      if (!updateResponse.ok) {
        var details = await updateResponse.json().catch(function () { return {}; });
        throw new Error(details.description || 'Could not replace the original set.');
      }
    }

    function restoreCartEditDraft() {
      var requestedId = new URLSearchParams(window.location.search).get('hand_edit');
      if (!requestedId) return;
      try {
        var stored = sessionStorage.getItem('HAND_CUSTOMIZER_EDIT_DRAFT');
        if (!stored) throw new Error('The saved edit session was not found. Return to the cart and click Edit Design again.');
        var draft = JSON.parse(stored);
        if (!draft || draft.groupId !== requestedId || String(draft.productId) !== String(root.dataset.handProductId)) {
          throw new Error('This saved design does not match the current product.');
        }
        if (!Array.isArray(draft.layout)) throw new Error('The saved design layout is invalid.');

        var selectedVariant = variantButtons.find(function (button) {
          return button.dataset.variantId === String(draft.variantId);
        });
        if (!selectedVariant) throw new Error('The original product option is no longer available.');

        var matchedPatches = draft.layout.map(function (placement) {
          if (!Array.isArray(placement) || placement.length < 7) return null;
          return patchButtons.find(function (button) {
            return button.dataset.patchVariantId === String(placement[1]);
          }) || null;
        });
        if (matchedPatches.some(function (button) { return !button; })) {
          throw new Error('One or more original patches are currently unavailable. Your original set is safe in the cart; please return to the cart.');
        }

        editDraft = draft;
        chooseVariant(selectedVariant);
        draft.layout.forEach(function (placement, index) {
          state.surface = placement[0] === 'back' && doubleSided ? 'back' : 'front';
          addPatch(matchedPatches[index]);
          var item = state.placements[state.placements.length - 1];
          item.x = Number(placement[2]);
          item.y = Number(placement[3]);
          item.rotation = Number(placement[6]) || 0;
          applyPlacement(item);
        });
        renderSurface('front');
        updateSummary();
        if (editBanner) editBanner.hidden = false;
        addButton.textContent = 'Save changes to cart';
        status.textContent = 'Your saved design is ready to edit.';
        window.setTimeout(function () {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200);
      } catch (error) {
        if (editBanner) editBanner.hidden = false;
        addButton.disabled = true;
        status.textContent = error.message || 'Could not restore the saved design.';
      }
    }

    if (cancelEditButton) {
      cancelEditButton.addEventListener('click', function () {
        try { sessionStorage.removeItem('HAND_CUSTOMIZER_EDIT_DRAFT'); } catch (error) {}
        window.location.assign(root.dataset.cartUrl);
      });
    }

    addButton.addEventListener('click', async function () {
      if (!state.variantId) {
        status.textContent = 'Please choose a product option.';
        return;
      }

      addButton.disabled = true;
      status.textContent = 'Preparing your DIY preview…';

      var customizerId =
        'HAND-' +
        Date.now().toString(36).toUpperCase() +
        '-' +
        Math.random().toString(36).slice(2, 7).toUpperCase();

      var compactLayout = state.placements.map(function (item) {
        return [
          item.surface,
          item.variantId,
          Math.round(item.x * 10) / 10,
          Math.round(item.y * 10) / 10,
          item.widthCm,
          item.heightCm,
          item.rotation
        ];
      });

      var layoutString = JSON.stringify(compactLayout);
      var toteProperties = {
        'Selected option': state.variantTitle,
        'Patches': state.placements.length
          ? state.placements.map(function (item) { return item.name; }).join(', ')
          : 'No patches',
        'Front patches': state.placements.filter(function (item) { return item.surface === 'front'; }).map(function (item) { return item.name; }).join(', ') || 'No patches',
        'Back patches': state.placements.filter(function (item) { return item.surface === 'back'; }).map(function (item) { return item.name; }).join(', ') || 'No patches',
        '_HAND Customizer ID': customizerId,
        '_HAND Layout Version': '4',
        '_HAND Bag Size': bagWidthCm + 'x' + bagHeightCm + 'cm'
      };

      for (var i = 0, chunk = 1; i < layoutString.length; i += 240, chunk += 1) {
        toteProperties['_HAND Layout ' + chunk] = layoutString.slice(i, i + 240);
      }

      var grouped = {};
      state.placements.forEach(function (item) {
        var groupKey = item.variantId + '|' + item.surface;
        if (!grouped[groupKey]) {
          grouped[groupKey] = { variantId: item.variantId, surface: item.surface, quantity: 0 };
        }
        grouped[groupKey].quantity += 1;
      });

      var baseLineKey = '';

      try {
        var previewFile = await buildDiyPreviewFile(customizerId);
        var detailFile = null;
        try {
          detailFile = await buildDiyDetailFile(customizerId);
        } catch (detailError) {
          console.warn('HAND patch detail could not be generated:', detailError);
        }
        status.textContent = 'Uploading your DIY preview…';

        var baseFormData = new FormData();
        baseFormData.append('id', String(state.variantId));
        baseFormData.append('quantity', '1');

        Object.keys(toteProperties).forEach(function (key) {
          baseFormData.append('properties[' + key + ']', String(toteProperties[key]));
        });

        baseFormData.append(
          'properties[_HAND DIY Preview]',
          previewFile,
          previewFile.name
        );
        if (detailFile) {
          baseFormData.append('properties[_HAND Patch Detail]', detailFile, detailFile.name);
        }

        var baseResponse = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: baseFormData
        });

        // If a second file property is unsupported, preserve the original cart-add flow.
        if (!baseResponse.ok && detailFile && baseResponse.status === 422) {
          baseFormData.delete('properties[_HAND Patch Detail]');
          baseResponse = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: baseFormData
          });
        }
        var baseData = await baseResponse.json().catch(function () { return {}; });
        if (!baseResponse.ok) {
          throw new Error(
            baseData.description ||
            baseData.message ||
            'Could not upload the customised product preview.'
          );
        }

        baseLineKey =
          baseData.key ||
          (baseData.items && baseData.items[0] && baseData.items[0].key) ||
          '';

        var patchItems = [];
        Object.keys(grouped).forEach(function (groupKey) {
          var group = grouped[groupKey];
          patchItems.push({
            id: Number(group.variantId),
            quantity: group.quantity,
            properties: {
              '_HAND Customizer ID': customizerId,
              '_HAND Role': 'Patch add-on',
              '_HAND Surface': group.surface === 'back' ? 'Back' : 'Front'
            }
          });
        });

        if (patchItems.length) {
          status.textContent = 'Adding your selected patches…';

          var patchResponse = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: patchItems })
          });

          if (!patchResponse.ok) {
            var patchError = await patchResponse.json().catch(function () { return {}; });

            if (baseLineKey) {
              var changeUrl = root.dataset.cartAddUrl.replace(/add\.js$/, 'change.js');
              await fetch(changeUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ id: baseLineKey, quantity: 0 })
              }).catch(function () {});
            }

            throw new Error(
              patchError.description ||
              patchError.message ||
              'Could not add the selected patches.'
            );
          }
        }

        if (editDraft && editDraft.groupId) {
          status.textContent = 'Replacing your original customised set…';
          try {
            await removeHandCartGroup(editDraft.groupId);
          } catch (replacementError) {
            try {
              await removeHandCartGroup(customizerId);
              throw new Error('Could not replace the original set. Your original design is still in the cart. Please try again.');
            } catch (rollbackError) {
              if (rollbackError.message && rollbackError.message.indexOf('Your original design is still') !== -1) {
                throw rollbackError;
              }
              throw new Error('Could not finish replacing the set. Please review your cart for duplicates before checking out.');
            }
          }
          try { sessionStorage.removeItem('HAND_CUSTOMIZER_EDIT_DRAFT'); } catch (error) {}
        }
        status.textContent = 'Added. Opening your cart…';
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent =
          error.message ||
          'Could not save the DIY preview. Please try again.';
        addButton.disabled = false;
      }
    });

    if (variantButtons.length) chooseVariant(variantButtons[0]);
    renderSurface('front');
    updateSummary();
    restoreCartEditDraft();
  }

  function initAll(scope) {
    var base = scope || document;
    if (base.matches && base.matches('[data-hand-patch-customizer]')) initCustomizer(base);
    base.querySelectorAll('[data-hand-patch-customizer]').forEach(initCustomizer);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
